import { LogOut } from "lucide-react";
import { Header } from "../../../components/layout/header";
import { Main } from "../../../components/layout/main";
import { Button } from "../../../components/ui/button";
import { useAuthStore } from "../../../stores/auth";
import { DatePicker } from "../../../components/ui/date-picker";
import { useState } from "react";
import SelectComponent from "../../../components/select";
import { useAttendance } from "../../../hooks/attendance";
import TableCustomer from "../../../components/table";
import DropdownCheckbox from "../../../components/dropdown-checkbox";
import UpdateAttendance from "./components/update";

const Attendance: React.FC = () => {
    const { logout } = useAuthStore();

    const { data, isLoading, query, setQuery } = useAttendance();

    const handleDateChange = (newDate: Date | undefined) => {
        if (newDate) setQuery({ ...query, attendanceDate: newDate });
    };

    const handleSelectChange = (value: string) => {
        setQuery({ ...query, isCheckedIn: value });
    };

    const [hideColumn, setHideColumn] = useState<string[]>([]);

    return (
        <>
            <Header fixed className='flex justify-between w-[inherit]'>
                <div className='mr-0 flex items-center justify-end space-x-4 w-[inherit]'>
                    <Button variant="outline" size="icon" onClick={logout}>
                        <LogOut />
                    </Button>
                </div>
            </Header>
            <Main>
                <h4 className="text-2xl font-bold">Attendance</h4>
                <div className="flex gap-4 mt-4 justify-between">
                    {/* SET CHỈ PICK ĐƯỢC NGÀY HÔM NAY VÀ NGÀY TRƯỚC ĐÓ  */}
                    <div className="flex gap-2">
                        <DatePicker label="Pick a date" date={query.attendanceDate} onChange={handleDateChange} endDate={new Date()} />
                        <SelectComponent
                            options={[{ label: "All", value: "all" }, { label: "Checked In", value: "true" }, { label: "Not Checked In", value: "false" }]}
                            onChange={handleSelectChange}
                            placeholder="Select an option"
                        />
                    </div>

                    <DropdownCheckbox options={columns} selected={hideColumn} setSelected={setHideColumn} />

                </div>
                <div className="mt-4">
                    <p className="text-sm font-bold text-gray-500">{`Checked In ${data?.countUserCheckedIn}/${data?.total}`}</p>

                    <TableCustomer
                        columns={columns}
                        data={data?.attendances || []}
                        loading={isLoading}
                        hideColumn={hideColumn}
                        Update={UpdateAttendance}
                    />
                </div>
            </Main >
        </>
    )
}

export default Attendance;


const columns = [
    {
        label: "Avatar",
        value: "user.avatarUrl",
        isImage: true
    },
    {
        label: "Full Name",
        value: "user.name"
    },
    {
        label: "Checked In",
        value: "attendance",
        isBoolean: true
    },
    {
        label: "Check-in Type",
        value: "attendance.checkInType"
    },
    {
        label: "Check-in Image",
        value: "attendance.checkInImage",
        isImage: true,
        noRound: true,
        square: false
    },
    {
        label: "Check-in Time",
        value: "attendance.checkTime",
        isTime: true
    },
    {
        label: "Is Late",
        value: "attendance.isLate"
    },
    {
        label: "Late Time (minutes)",
        value: "attendance.lateTime"
    }
]

